import { render, staticRenderFns } from "./TransportsModule.vue?vue&type=template&id=129d9ce6&scoped=true"
import script from "./TransportsModule.vue?vue&type=script&lang=js"
export * from "./TransportsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129d9ce6",
  null
  
)

export default component.exports